export const ROOT_ID = 'wptelegram-settings';
